import { Component, Input } from '@angular/core';

// Placeholder for unfinished screens. Used as a route page (defaults) or
// inline in a tab with its own heading/message.
@Component({
  selector: 'app-comming-soon',
  templateUrl: './comming-soon.component.html',
  styleUrls: ['./comming-soon.component.scss']
})
export class CommingSoonComponent {
  @Input() heading = 'Coming soon';
  @Input() message = "We're working on this section. It will be available here shortly.";
}
